import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, FormGroup, Input, Button, Label } from "reactstrap";
import {
  STEP_1_ADD_REQUIRED_DOCUMENT,
  STEP_1_REMOVE_REQUIRED_DOCUMENT,
  STEP_1_REQUIRED_DOCUMENT_FIELD_VALUES,
} from "../../../redux/actions/ActionTypes";
import { SingleStringFirstLetterCaps } from "../../../utils/functions/CustomFunctions";

function ADDITIONAL_DOCUMENTS(props) {
  const { CreateDocumentForm = {}, dispatch } = props;
  const { step1 = {} } = CreateDocumentForm;
  const { additionalDocuments = [] } = step1;

  //New Document
  const AddNewDocument = () => {
    dispatch({
      type: STEP_1_ADD_REQUIRED_DOCUMENT,
    });
  };

  //Remove Document
  const removeDocument = (event) => {
    const documentId = event.currentTarget.dataset.document_id;
    dispatch({
      type: STEP_1_REMOVE_REQUIRED_DOCUMENT,
      documentId,
    });
  };

  //Field Value Change
  const fieldValueChange = (event, documentId, field) => {
    const { value = "" } = event.target;
    let valueToStore = value;
    if (field === "documentName") {
      valueToStore = SingleStringFirstLetterCaps(value);
    } else if (field === "isRequired") {
      const { checked } = event.target;
      valueToStore = checked;
    }
    dispatch({
      type: STEP_1_REQUIRED_DOCUMENT_FIELD_VALUES,
      documentId,
      field,
      payload: valueToStore,
    });
  };

  return (
    <Fragment>
      {additionalDocuments.map(
        (
          { documentName, description, documentId, isRequired },
          documentIndex
        ) => (
          <Row key={`document_list_${documentIndex}`}>
            <Col md={1} />
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  required
                  name={`document_${documentId}`}
                  id={`document_${documentId}`}
                  placeholder="Document Name"
                  value={documentName || ""}
                  onChange={(event) =>
                    fieldValueChange(event, documentId, "documentName")
                  }
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Input
                  type="textarea"
                  required
                  name={`description_${documentId}`}
                  id={`description_${documentId}`}
                  placeholder="Description"
                  value={description || ""}
                  onChange={(event) =>
                    fieldValueChange(event, documentId, "description")
                  }
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup check style={{ marginTop: "8px" }}>
                <Label check>
                  <Input
                    style={{ cursor: "pointer" }}
                    type="checkbox"
                    name="isRequired"
                    checked={isRequired}
                    onChange={(event) =>
                      fieldValueChange(event, documentId, "isRequired")
                    }
                  />{" "}
                  Required
                </Label>
              </FormGroup>
            </Col>
            <Col md={2}>
              {additionalDocuments.length > 1 && (
                <i
                  className="fas fa-trash"
                  data-document_id={documentId}
                  style={{
                    color: "#c72e39",
                    margin: "12px",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={removeDocument}
                />
              )}
            </Col>
          </Row>
        )
      )}
      <Row>
        <Col md={1} />
        <Col md={2}>
          <Button color="primary" onClick={AddNewDocument}>
            <i className="fas fa-plus" /> Document
          </Button>
        </Col>
        <Col md={9} />
      </Row>
    </Fragment>
  );
}
const getState = ({ CreateDocumentForm }) => {
  return {
    CreateDocumentForm,
  };
};
const mapDispatcToProps = (dispatch) => ({
  ...bindActionCreators({}, dispatch),
  dispatch,
});
export default connect(getState, mapDispatcToProps)(ADDITIONAL_DOCUMENTS);
